/**
 * 通用类型守卫与安全转换工具
 * - isRecord: 检查值是否为非 null 的对象
 * - toStringSafe: 将字符串/数字安全转换为字符串
 */

export const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

export const toStringSafe = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return Number.isFinite(value) ? value.toString() : undefined;
  return undefined;
};
